import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/font.css";
import "./assets/css/styles.css";
import vuetify from "./plugins/vuetify";
import vueFbCustomerChat from "./plugins/vue-fb-customer-chat";

import VueI18n from "vue-i18n";
import en_file from "./lang/en_US";
import th_file from "./lang/th_TH";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueSocialSharing from "vue-social-sharing";
import wysiwyg from "vue-wysiwyg";

Vue.use(wysiwyg, {
  hideModules: {
    bold: false,
    removeFormat: true,
  },
}); // config is optional. more below

Vue.use(VueSocialSharing);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "th",
  messages: {
    th: th_file,
    en: en_file,
  },
  fallbackLocale: "en",
});

Vue.mixin({
  methods: {
    //
    getCateId() {
      if (this.$route.name === "AllPortfolioByCategory") {
        return this.$route.params.slug === "รวม"
          ? "0"
          : this.$route.params.slug
              .split("-")
              .slice(-1)
              .pop();
      }
    },
  },
});

moment.locale("th");

Vue.use(require("vue-moment"));
Vue.config.productionTip = false;

new Vue({
  router,
  vueFbCustomerChat,
  vuetify,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
